/* Diagnosi: aprendo il sito con ?elxdebug nell'indirizzo compare un riquadro che dice
   se le animazioni sono attive su questo telefono e perché. Non si vede in nessun altro caso. */
(function () {
  if (location.search.indexOf('elxdebug') === -1) return;
  function show() {
    var h = document.documentElement, mq = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)').matches : 'n/d';
    var d = document.getElementById('elx-debug') || document.createElement('div');
    d.id = 'elx-debug';
    d.textContent = 'ANIMAZIONI: ' + (h.classList.contains('elx-motion') ? 'ATTIVE' : 'SPENTE') +
      '\nRiduci movimento sul telefono: ' + (mq === true ? 'SÌ (per questo sono spente)' : mq === false ? 'no' : mq) +
      '\nIntersectionObserver: ' + ('IntersectionObserver' in window ? 'sì' : 'NO') +
      '\nElementi animati: ' + document.querySelectorAll('.elx-reveal').length + ' (già comparsi: ' + document.querySelectorAll('.elx-reveal.is-in').length + ')' +
      '\nTema: ' + (window.Shopify && Shopify.theme ? Shopify.theme.id : '?') + ' · larghezza ' + innerWidth +
      '\n' + navigator.userAgent.slice(0, 110);
    document.body.appendChild(d);
  }
  window.addEventListener('load', function () { show(); window.addEventListener('scroll', function () { clearTimeout(window.__elxd); window.__elxd = setTimeout(show, 300); }, { passive: true }); });
})();

/* ELAXO · movimento (08-10-2026). Vanilla, nessuna libreria.
   - Comparsa allo scorrimento: solo elementi SOTTO la prima schermata, una volta sola.
   - Se manca IntersectionObserver o l'utente riduce il movimento, non si nasconde nulla.
   - Rete di sicurezza: a 2,5 s ogni elemento ancora nascosto ma già nello schermo compare. */
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('elx-motion') || !('IntersectionObserver' in window)) return;

  // gruppi: [selettore, figli da scaglionare (opzionale)]
  var GROUPS = [
    ['.section-header'],
    ['.elx-head'],
    ['.elx-altri__title'],
    ['.elx-attivi__head, .elx-attivi__title'],
    ['.blockquote__text'],
    ['.blockquote__person-box'],
    ['.rich-text__text'],
    ['[id$="__concerns"] .multicolumn-card'],
    ['[id$="__perche"] .multicolumn-card'],
    ['.image-with-text__text ol > li'],
    ['.image-with-text__text ol + p'],
    ['.image-with-text__text > p'],
    ['.image-with-text__button-wrapper'],
    ['.elx-proof__item'],
    ['.elx-attivi__card'],
    ['.elx-attivi__more'],
    ['[id*="__collapsible-content"] .accordion'],
    ['.elx-rv__summary'],
    ['.article-card-wrapper, .article-card'],
    ['.elx-altri__card'],
    ['.elx-rmix__card'],
    ['.elx-canali__row'],
    ['.elx-dove__item'],
    ['.elx-dove__pro']
  ];
  var ZOOM = '[id$="__ritual"] .image-with-text__media, [id$="__fondatori"] .image-with-text__media, [id$="__apertura"] .image-with-text__media, [id$="__concerns"] .multicolumn-card__picture, .elx-altri__media, .article-card__image-wrapper';
  var vh = window.innerHeight;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -14% 0px' });

  function below(el) { return el.getBoundingClientRect().top > vh; }
  function prep(el, cls, i) {
    if (el.closest('[id$="__hero"], .product__info-container, .product__media-wrapper, .shopify-section-group-header-group')) return;
    if (!below(el)) return;
    el.classList.add(cls);
    if (i) el.style.setProperty('--i', i % 4);
    io.observe(el);
  }
  function scan(scope) {
    GROUPS.forEach(function (g) {
      var list = scope.querySelectorAll(g[0]);
      var lastParent = null, n = 0;
      Array.prototype.forEach.call(list, function (el) {
        if (el.classList.contains('elx-reveal')) return;
        if (el.parentElement !== lastParent) { lastParent = el.parentElement; n = 0; }
        prep(el, 'elx-reveal', n++);
      });
    });
    Array.prototype.forEach.call(scope.querySelectorAll(ZOOM), function (el) { prep(el, 'elx-zoom', 0); });
    Array.prototype.forEach.call(scope.querySelectorAll('.elx-rv__bar'), function (el) { prep(el, 'elx-bar', 0); });
    var nf = 0;
    Array.prototype.forEach.call(scope.querySelectorAll('.elx-parole__w'), function (el) { prep(el, 'elx-fill', nf++); });
  }
  // TESTO CHE SI ACCENDE SCORRENDO (alla Apple, richiesta di Alessio 08-10): le parole partono chiare
  // e prendono il colore pieno man mano che il blocco sale nello schermo; risalendo tornano chiare.
  // Solo opacity sulle parole; calcolo solo per i blocchi visibili, una volta per fotogramma.
  var TONE = [
    'main .section-header__title', 'main .elx-h2', '.elx-altri__title', '.elx-attivi__title',
    '[id$="__pdrn_def"] .rich-text__text p', '[id$="__perche"] .multicolumn-card__text',
    '[id$="__fondatori"] .image-with-text__text p', '[id$="__cliente"] .blockquote__text',
    '[id$="__concerns"] .multicolumn-card__text', '.elx-attivi__text'
  ].join(',');
  function splitWords(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), nodes = [], n;
    while ((n = walker.nextNode())) { if (n.textContent.trim()) nodes.push(n); }
    nodes.forEach(function (t) {
      var frag = document.createDocumentFragment();
      t.textContent.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
        var w = document.createElement('span'); w.className = 'elx-tw'; w.textContent = part; frag.appendChild(w);
      });
      t.parentNode.replaceChild(frag, t);
    });
    return root.querySelectorAll('.elx-tw');
  }
  var toneItems = [];
  Array.prototype.forEach.call(document.querySelectorAll(TONE), function (el) {
    if (el.closest('[id$="__hero"], .product__info-container') || el.querySelector('.elx-tw')) return;
    // 25-10 (rev 21): sulle schede prodotto si «accendono» solo i titoli; i testi si leggono pieni da subito
    if (document.body.classList.contains('template-product') && !el.matches('.section-header__title, .elx-h2, .elx-altri__title, .elx-attivi__title')) return;
    var words = splitWords(el);
    if (words.length < 2) return;
    el.classList.add('elx-tone');
    toneItems.push({ el: el, words: words, lit: -1, on: false });
  });
  if (toneItems.length) {
    // innesco doppio: al fotogramma successivo e, in riserva, dopo 120 ms (se il disegno è in pausa)
    var pending = false;
    function schedule() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(run);
      setTimeout(run, 120);
    }
    function run() { if (!pending) return; pending = false; tick(); }
    function tick() {
      var vh = window.innerHeight;
      toneItems.forEach(function (it) {
        var r = it.el.getBoundingClientRect();
        if (r.bottom < -vh * 0.2 || r.top > vh * 1.2) return;
        // 0 quando il blocco entra dal basso (90% dello schermo), 1 quando arriva a metà schermo
        var p = (vh * 0.9 - r.top) / (vh * 0.4 + r.height * 0.6);
        p = p < 0 ? 0 : p > 1 ? 1 : p;
        var lit = Math.round(p * it.words.length);
        if (lit === it.lit) return;
        for (var i = 0; i < it.words.length; i++) it.words[i].classList.toggle('is-lit', i < lit);
        it.lit = lit;
      });
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    tick();
  }

  // Recensione: ogni parola in uno <span> (solo testo, nessun HTML toccato), poi compare in sequenza
  Array.prototype.forEach.call(document.querySelectorAll('[id$="__cliente"] .blockquote__text:not(.elx-tone)'), function (q) {
    if (!below(q) || q.querySelector('.elx-w')) return;
    var i = 0;
    Array.prototype.slice.call(q.childNodes).forEach(function (n) {
      if (n.nodeType !== 3) return;
      var frag = document.createDocumentFragment();
      n.textContent.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
        var w = document.createElement('span'); w.className = 'elx-w'; w.style.setProperty('--w', i++); w.textContent = part; frag.appendChild(w);
      });
      n.parentNode.replaceChild(frag, n);
    });
    q.classList.add('elx-words'); io.observe(q);
  });
  scan(document);

  // Reti di sicurezza: nessun contenuto deve poter restare invisibile.
  // 1) a 2,5 s dal caricamento; 2) durante lo scorrimento, se l'osservatore non scatta
  //    (listener passivo, al massimo ogni 250 ms, si stacca quando non resta nulla).
  var PENDING = '.elx-reveal:not(.is-in), .elx-zoom:not(.is-in), .elx-bar:not(.is-in), .elx-fill:not(.is-in), .elx-words:not(.is-in)';
  function sweep() {
    var left = document.querySelectorAll(PENDING);
    Array.prototype.forEach.call(left, function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.95 && r.bottom > 0) { el.classList.add('is-in'); io.unobserve(el); }
    });
    return left.length;
  }
  setTimeout(sweep, 2500);
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    setTimeout(function () {
      ticking = false;
      if (!sweep()) window.removeEventListener('scroll', onScroll);
    }, 250);
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  // Invito a scorrere: il carosello accenna lo spostamento una volta (solo telefono)
  function peek(wrapper, delay) {
    if (!wrapper || wrapper.children.length < 2 || window.innerWidth >= 750) return;
    var touched = false;
    wrapper.addEventListener('touchstart', function () { touched = true; }, { passive: true, once: true });
    var po = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting || e.intersectionRatio < 0.6) return;
        po.disconnect();
        setTimeout(function () {
          if (touched) return;
          wrapper.classList.add('elx-peek');
          wrapper.addEventListener('animationend', function () { wrapper.classList.remove('elx-peek'); }, { once: true });
        }, delay);
      });
    }, { threshold: [0.6] });
    po.observe(wrapper);
  }
  peek(document.querySelector('[id$="__concerns"] .swiper-wrapper'), 350);
  peek(document.querySelector('.product__media-list .swiper-wrapper'), 1400);
  peek(document.querySelector('[id$="__approfondimenti"] .swiper-wrapper'), 350);
  peek(document.querySelector('.elx-scorc__list'), 600);
  peek(document.querySelector('.elx-rmix__list'), 400);

  // Customizer: ripassa la sezione ricaricata
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

/* Prima schermata della Home (solo telefono): barre di avanzamento + frecce.
   Indipendente dal movimento: chi riduce il movimento vede le barre piene senza animazione. */
(function () {
  if (window.innerWidth >= 750) return;
  var hero = document.querySelector('[id$="__hero"]');
  if (!hero) return;
  var box = hero.querySelector('.slideshow');
  var host = hero.querySelector('.slideshow__swiper');
  if (!box || !host) return;
  var lang = (document.documentElement.lang || 'it').slice(0, 2);
  var L = { it: ['Foto precedente', 'Foto successiva', 'Vai alla foto'], en: ['Previous photo', 'Next photo', 'Go to photo'],
    de: ['Vorheriges Foto', 'Nächstes Foto', 'Zum Foto'], fr: ['Photo précédente', 'Photo suivante', 'Aller à la photo'],
    es: ['Foto anterior', 'Foto siguiente', 'Ir a la foto'], nl: ['Vorige foto', 'Volgende foto', 'Ga naar foto'],
    pt: ['Foto anterior', 'Foto seguinte', 'Ir para a foto'] }[lang] || ['Foto precedente', 'Foto successiva', 'Vai alla foto'];
  var tries = 0;
  (function wait() {
    var sw = host.swiper;
    if (!sw) { if (tries++ < 80) return setTimeout(wait, 100); return; }
    var n = sw.slides.length;
    if (n < 2) return;
    var ms = (Number(box.dataset.delay) || 4) * 1000 + (Number(box.dataset.speed) || 1) * 1000;
    var ctrl = document.createElement('div');
    ctrl.className = 'elx-hero-ctrl';
    ctrl.style.setProperty('--elx-hero-ms', ms + 'ms');
    var chev = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="' + d + '"/></svg>'; };
    var html = '<div class="elx-hero-ctrl__bars">';
    for (var i = 0; i < n; i++) html += '<button type="button" class="elx-hero-ctrl__bar" data-i="' + i + '" aria-label="' + L[2] + ' ' + (i + 1) + '"><i></i></button>';
    html += '</div><button type="button" class="elx-hero-ctrl__btn" data-dir="-1" aria-label="' + L[0] + '">' + chev('M15 5l-7 7 7 7') + '</button>' +
      '<button type="button" class="elx-hero-ctrl__btn" data-dir="1" aria-label="' + L[1] + '">' + chev('M9 5l7 7-7 7') + '</button>';
    ctrl.innerHTML = html;
    host.parentNode.appendChild(ctrl);
    // in basso a sinistra sulla foto: 12 px sopra il bordo inferiore della foto della slide attiva
    function place() {
      var img = sw.slides[sw.activeIndex] && sw.slides[sw.activeIndex].querySelector('.slideshow-slide__img');
      if (!img) return;
      var top = img.getBoundingClientRect().top - host.parentNode.getBoundingClientRect().top + img.offsetHeight - 52;
      ctrl.style.setProperty('--elx-hero-top', Math.max(12, Math.round(top)) + 'px');
    }
    place();
    window.addEventListener('resize', place, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(place).observe(host);
    var bars = ctrl.querySelectorAll('.elx-hero-ctrl__bar');
    function paint() {
      var a = sw.activeIndex;
      Array.prototype.forEach.call(bars, function (b, i) {
        b.classList.remove('is-active');
        b.classList.toggle('is-done', i < a);
        b.setAttribute('aria-current', i === a ? 'true' : 'false');
      });
      void ctrl.offsetWidth; // riavvia l'animazione della barra attiva
      bars[a] && bars[a].classList.add('is-active');
    }
    ctrl.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      if (b.dataset.i) return sw.slideTo(Number(b.dataset.i));
      var dir = Number(b.dataset.dir), a = sw.activeIndex;
      sw.slideTo(dir > 0 ? (a + 1) % n : (a - 1 + n) % n);
      if (sw.autoplay && sw.autoplay.start) sw.autoplay.start();
    });
    sw.on('slideChange', paint);
    sw.on('autoplayStop', function () { ctrl.classList.add('is-paused'); });
    sw.on('autoplayStart', function () { ctrl.classList.remove('is-paused'); });
    paint();
  })();
})();
